import React, { useEffect, useState } from 'react';
import { NavigationMenu } from './NavigationMenu/NavigationMenu';
import './Menu.scss';
import { TopMenu } from './TopMenu/TopMenu';
import { FloatingSummaryBubbles } from './FloatingSummaryBubbles/FloatingSummaryBubbles';
import { useGetActiveMenuQuery } from '../store/menu/menuApi';
import { Category } from './Category/Category';

export const Menu = (): JSX.Element => {
	const { data: menu, isLoading: isLoadingMenu } = useGetActiveMenuQuery();
	const { categories = [] } = menu ?? { categories: [] };

	const [selectedCategoryId, setSelectedCategoryId] = useState<string>(categories?.[0]?.id ?? null);

	useEffect(() => {
		setSelectedCategoryId(categories?.[0]?.id ?? null);
	}, [categories]);

	const handleNewCategorySelected = (newCategoryId: string): void => {
		setSelectedCategoryId(newCategoryId);
	};

	return (
		<div className="menuContainer">
			{isLoadingMenu ? (
				<div>Loading menu...</div>
			) : (
				<>
					<TopMenu />
					<NavigationMenu onCategoryChange={handleNewCategorySelected} />
					<Category menuId={menu.id} categoryId={selectedCategoryId} />
					<FloatingSummaryBubbles />
				</>
			)}
		</div>
	);
};
